<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Kategori"
    }
</script>

<style scoped>

</style>